var timePickerData = {
  name: 'timePicker',
  data: [{
    dropDownInputHeight: 28,
    columnWidth: 90,
    itemFontSize: 12,
    itemFontColor: 'rgba(0,0,0,0.85)',
    itemHeight: 24,
    selectedBg: 'rgba(0,0,0,0.04)',
    selectedFontColor: 'rgba(0,0,0,0.85)'
  }]
};
export default timePickerData;